'use client';

import dynamic from 'next/dynamic';

// Props for RealtimeHomeMode, adjust as needed
interface RealtimeHomeModeProps {
  subdomain: string;
}

// Props for RealtimePostMode, adjust as needed
interface RealtimePostModeProps {
  subdomain: string;
  id: string;
}

export const LazyRealtimeHomeMode = dynamic<RealtimeHomeModeProps>(
  () => import('./realtime-mode').then((mod) => mod.RealtimeHomeMode),
  {
    ssr: false,
  },
);

export const LazyRealtimePostMode = dynamic<RealtimePostModeProps>(
  () => import('./realtime-mode').then((mod) => mod.RealtimePostMode),
  {
    ssr: false,
  },
);
